import { render } from "./px-navbar.vue?vue&type=template&id=580e523a&scoped=true&ts=true"
import script from "./px-navbar.vue?vue&type=script&lang=ts"
export * from "./px-navbar.vue?vue&type=script&lang=ts"

import "./px-navbar.vue?vue&type=style&index=0&id=580e523a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580e523a"]])

export default __exports__